import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=8dcb8bdc&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=8dcb8bdc&prod&lang=scss&scoped=true"
import style1 from "./Shop.vue?vue&type=style&index=1&id=8dcb8bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb8bdc",
  null
  
)

export default component.exports